import React, { useEffect, useRef, useState } from "react";
import "./settings.css";
import { useContext } from "react";
import { UserContext } from "../../context/UserContext";
import { useNavigate } from "react-router-dom";
import { LoaderContext } from "../../context/LoaderContext";
import Navbar from "../../components/navbar/navbar";
import Loader from "../../components/loader/loader";
import Footer from "../../components/Footer/Footer";
import SideNav from "../../components/SideNav/sideNav";
import { API_URL } from "../../enviormentVariables";
import { DELETE, GET, POST, setAuth } from "../../utils/httpUtils";
import ArrowSvg from "../../assets/svg/arrowSvg";
import { SettingOption } from "../../components/SettingOption/setting-option";
import { ConfirmationModal } from "../../components/Modals/ConfirmationModal/confirmation-modal";
import Accordian from "../../components/Accoridan/Accordian";
import AccountSettings from "./AccountSettings/AccountSettings";
import NotificationSettings from "./NotificationSettings/NotificationSettings";
import SubscriptionSettings from "./SubscriptionSettings/SubscriptionSettings";
import DeveloperSettings from "./DeveloperSettings/DeveloperSettings";
import PrivacySettings from "./PrivacySettings/PrivacySettings";
import { AlertContext } from "../../context/AlertContext";
import { Alert, FunctionRevokeAllSessionUrls, RevokeAllSessionUrls } from "../../utils/genericUtils";
import InterfaceSettings from "./InterfaceSettings/InterfaceSettings";
import StorageSettings from "./StorageSettings/StorageSettings";

function Settings() {
  const { user, loginUser } = useContext(UserContext);
  const { show, showloader, hideloader } = useContext(LoaderContext);
  const { globalAlert } = useContext(AlertContext);
  const [sideNavOpen, setSideNavOpen] = useState(true);
  const [showDeleteDataModal, setShowDeleteDataModal] = useState(false);
  const [showDeleteAccountModal, setShowDeleteAccountModal] = useState(false);
  const router = useNavigate();

  //state
  const [settingsChanged, setSettingsChanged] = useState(false);
  const [settingsValid, setSettingsValid] = useState(true);

  //refs
  const settingsHeader = useRef(null);

  useEffect(() => {}, [showDeleteAccountModal, settingsChanged, settingsValid]);

  if (!user) return;

  function ToDashboard() {
    router("/dashboard");
  }

  function ToHome() {
    router("/");
  }

  const deleteDataModalId = "delete-data-confirmation-modal";
  const deleteAccountModalId = "delete-account-confirmation-modal";

  function ShowDeleteDataModal() {
    setShowDeleteDataModal(true);
  }

  function HideDeleteDataModal() {
    setShowDeleteDataModal(false);
  }

  function ShowDeleteAccountModal() {
    setShowDeleteAccountModal(true);
  }

  function HideDeleteAccountModal() {
    setShowDeleteAccountModal(false);
  }

  async function DeleteAccountData() {
    HideDeleteDataModal();
    showloader();
    RevokeAllSessionUrls();
    let delete_data_Res = await DELETE("/delete-account-data", undefined, user);
    hideloader();
    if (!delete_data_Res) {
      Alert(globalAlert, "success", "Success", "Account data successfully deleted");
    } else {
      Alert(globalAlert, "error", "Error", delete_data_Res.error.message ?? "unkown error");
    }
  }

  async function DeleteAccount() {
    HideDeleteAccountModal();
    showloader();
    RevokeAllSessionUrls();
    let response = await DELETE("/delete-account", undefined, user);
    hideloader();
    if (!response) {
      loginUser(null);
      localStorage.clear();
      ToHome();
    } else {
      Alert(globalAlert, "error", "Error", response.error.message ?? "unkown error");
    }
  }

  function RenderSettingOptions() {
    let elements = [];
    let settingsCount = 3;
    for (let i = 1; i <= settingsCount; i++) {
      elements.push(
        <SettingOption
          id={"setting-option-" + i}
          controlType={"toggle"}
          defaultValue={eval(`setting${i}`)}
          onChange={(value) => {
            eval(`setSetting${i}(value)`);
          }}
        />
      );
    }
    return elements;
  }

  const AccordianSections = [
    {
      title: "Account Info",
      content: (
        <AccountSettings
          onChanged={(isValid) => {
            setSettingsChanged(true);
            setSettingsValid(isValid);
          }}
        />
      ),
    },
    {
      title: "Notification Settings",
      content: <NotificationSettings {...user.settings} />,
    },
    {
      title: "Subscription Settings",
      content: <SubscriptionSettings />,
    },
    {
      title: "Developer Settings",
      content: <DeveloperSettings {...user.settings} />,
    },
    {
      title: "Privacy & Security",
      content: <PrivacySettings mfaEnabled={user.mfaVerified && user.mfaMethod !== ""} {...user.settings} />,
    },
    {
      title: "Interface Settings",
      content: <InterfaceSettings {...user.settings} />,
    },
    {
      title: "Storage Settings",
      content: <StorageSettings />,
    },
    {
      title: "Data Deletion Center",
      content: (
        <>
          {/* DELETE ACCOUNT DATA */}
          <ConfirmationModal
            onClickOut={HideDeleteDataModal}
            showDivider={true}
            animate={true}
            isActive={showDeleteDataModal}
            id={deleteDataModalId}
            includeCheckboxSafety={true}
            safetyText={"I Acknowledge that this action is Permenant."}
            header={"Do you want to Proceed?"}
            message={"Warning this action will delete your account data. This action cannot be reversed."}
            denyText={"I want to Keep Data."}
            confirmText={"I want to Delete my Data"}
            onDeny={HideDeleteDataModal}
            onConfirm={DeleteAccountData}
          />

          {/* DELETE ACCOUNT */}
          <ConfirmationModal
            onClickOut={HideDeleteAccountModal}
            showDivider={true}
            animate={true}
            isActive={showDeleteAccountModal}
            id={deleteAccountModalId}
            includeCheckboxSafety={true}
            safetyText={`I Acknowledge that this action is Permenant.`}
            header={"Do you want to Proceed?"}
            message={"Warning this action will delete your account and all of it's data. This action cannot be reversed."}
            denyText="I want to Keep My Account."
            confirmText="I want to Delete my Account"
            onDeny={HideDeleteAccountModal}
            onConfirm={DeleteAccount}
          />

          <button className="delete-data-button standard-button" onClick={ShowDeleteDataModal}>
            Delete All Account Data
          </button>
          <button className="delete-account-button standard-button" onClick={ShowDeleteAccountModal}>
            Delete Account
          </button>
        </>
      ),
    },
  ];

  function SetHeaderMargin(title, expanded) {
    let delta = expanded ? 100 : -100;
    let currentMargin = parseInt(settingsHeader.current.style.marginTop) ?? 0;
    if (isNaN(currentMargin)) currentMargin = 0;

    //set bounds on new margin
    let newMargin = currentMargin + delta;
    if (newMargin < 0) newMargin = 0;
    if (newMargin > 800) newMargin = 800;

    //set current margin
    settingsHeader.current.style.marginTop = newMargin + "px";
  }

  return (
    <>
      <Loader />
      <Navbar active={"Dashboard"} />
      <section className="settings-page-bg">
        <SideNav />
        <section className="main-settings">
          {/* header */}
          <div className="settings-header-container" ref={settingsHeader}>
            <h1 className="settings-header">File Freak Settings</h1>
          </div>

          <button className="back-button standard-button" onClick={ToDashboard}>
            <ArrowSvg class={"svg"} />
            Back To Dashboard
          </button>

          {/* Settings List */}
          <section className="settings-list">
            <Accordian id="settings-accordian" animate={false} defaultOpen={true} sections={AccordianSections} onSectionToggle={SetHeaderMargin} />

            {/* Dynamically Render Settings List */}

            {/* Global Settings Save Button */}
            {settingsChanged && (
              <div className="settings-list-controls">
                <button className="standard-button" onClick={() => window.location.reload()}>
                  Cancel
                </button>
                <button className="standard-button" disabled={!settingsValid}>
                  Save
                </button>
              </div>
            )}
          </section>
        </section>
      </section>
      <Footer />
    </>
  );
}

export default Settings;
